import { formatDate } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { GridApi, ColumnApi, ColDef, RowClickedEvent, PaginationChangedEvent, GridReadyEvent, Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, RowClassRules } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import * as XLSX from 'xlsx';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

export interface CustomerFilter {
  "columns"?: any;
  "name"?: string,
  "mid"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "sendDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "rid"?:string,
  "status"?:string,
  "orderId"?:string,
  "transactionType"?:string,
  "dateFrom"?:string,
  "dateTo"?:string,
  "customerMobile"?:string,
  "Status"?:string,
  "user_type"?:string
}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}

@Component({
  selector: 'app-reconciliation-report',
  templateUrl: './reconciliation-report.component.html',
  styleUrls: ['./reconciliation-report.component.scss']
})
export class ReconciliationReportComponent implements OnInit {

  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName:string;
  public searchMID: string ;
  public resellerPartnerId:string;
  public Status:string;
  public searchFromDate: string;
  public searchToDate: string;
  public selectedMerchant: string;  
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  user_type:'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean= true;
  private gridApi!: GridApi;
   public rowData!: IMerchantData[];
   collectiondata: number=0;
   collectionSize: number = 0;
   currentPage: number = 1;
   public permissions: any = '';
   Resultdata: any;
   resellerListOptions: any;
   merchantStatusdata: any;
   private gridColumnApi!: ColumnApi;
   currentDate:any=new Date();
   private filterObj: any = {};
   globalSearch: string = '';
   private innerWidth: number;
   modalConfigAdd: ModalConfig;
   modalConfigEdit: ModalConfig;
   modalConfigMerchant: ModalConfig;
   modalConfigReport: ModalConfig;
   image : any;
   mindatadis: boolean = true;
   loading: boolean = false;
   customerMobile :any;
   transactionType : any;
   status :any;
   orderId : any;
   dateFrom :any;
   dateTo : any;

   public rowClassRules: RowClassRules = {
    // row style function
    "color-red": (params) => {
      return params.data.closingBalance != params.data.systemClosingBalance;
    }
  };


   public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;

  public columnDefs: ColDef[] = [
    {field: 'mobileNumber',headerName: 'Mobile Number', resizable: true, cellRenderer: 'agGroupCellRenderer'},
    {field: 'userType', headerName: 'User Type'},
    {field: 'date',headerName: 'Date'},
    {field: 'walletOutward',headerName: 'Wallet Outward'},
    {field: 'walletInward',headerName: 'Wallet Inward'},
    {field: 'serviceCharges',headerName: 'Service Charges'},
    {field: 'topup',headerName: 'Topup Online'},
    {field: 'topupOffline',headerName: 'Topup Offline'},
    {field: 'cashback',headerName: 'Cashback'},
    {field: 'total',headerName: 'Total',},
    {field: 'openingBalance', headerName: 'Opening Balance'},
    {field: 'closingBalance',headerName: 'Closing Balance'},
    {field: 'systemClosingBalance',headerName: 'System Closing Balance'}
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  
  constructor(private menuService: MenusService,private location : Location,private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService, private exportTrackingService: ExportTrackingService) {
    this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
  }
  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    // const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = "hello";
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.modalConfigBlocked = {
      modalTitle: "Customer Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigReport = {
      modalTitle: "Customer Screening Report",
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

  }

  downloadPdf(data:any,info:any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
  if(data){
      const linkSource =data;
      const downloadLink = document.createElement('a');
      const fileName = info+'_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    }else{
      this. mindatadis = false;
      this.loading = false
    }
    }


  setPageSize(){
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }
  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }


  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Customer_Reconciliation_Report' + "_" + referenceId;

    const filter: CustomerFilter = {}
    debugger
    if(this.Status !="")
    {

      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else{
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }
     if (this.Status != "") {
       } else {
         if (this.searchMerName || '') filter.name = this.searchMerName || '';
       }
       if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
       filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
       filter.name = filter.name + '|'; //added | for userType
    
      if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    if (this.Status) filter.Status=this.Status||'';
    if (this.searchFromDate) filter.startDate = this.searchFromDate;
    if (this.searchToDate) filter.endDate = this.searchToDate;

    if(this.customerMobile==undefined){
      filter.customerMobile = "";
    }else{
      filter.customerMobile = this.customerMobile;
    }
    
    filter.dateFrom = this.dateFrom;

    return this.merchantService.getReconciliationReport(filter.dateFrom)
      .subscribe((data) => {
        debugger
        const expData: any[] = [];
        console.log("Customer Data ::"+data);
        (data?.data || data?.merchants || data || []).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if(!(col?.field=="actions"))

            {
            if (col?.field) tempRec[col?.field] = curr[col?.field]

          }})
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  // Excel export method with audit tracking
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // First, track the export for audit logging
    this.exportTrackingService.trackExcelExport(
      excelFileName,
      json.length,
      'RECONCILIATION_REPORT',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Reconciliation report export tracked in audit logs:', response);
        // Proceed with actual export after audit tracking
        this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);
        // Proceed with export even if tracking fails since audit was logged by interceptor
        this.performExcelExport(json, excelFileName);
      }
    });
  }

  // Perform the actual Excel export after audit tracking
  private performExcelExport(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions"))
      {
       tempRec[index] = col
       index++;
    }})
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col:any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  // Helper method to get current filter state for audit logging
  private getCurrentFilters(): any {
    return {
      merchantName: this.searchMerName || '',
      status: this.Status || '',
      customerMobile: this.customerMobile || '',
      dateFrom: this.dateFrom || ''
    };
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  onSearchPayments(){
    const filter: CustomerFilter = {}
    console.log("Customer Mobile :"+this.customerMobile);
    console.log("Date From : "+this.dateFrom);
   

    if(this.customerMobile != undefined){
      filter.customerMobile = this.customerMobile;
    }
    else{
      filter.customerMobile = "";
    }

    if(this.dateFrom != ""){
      filter.dateFrom = this.dateFrom;
    }else{
      filter.dateFrom = "";
    }



    console.log("Filter : "+JSON.stringify(filter));
    this.merchantService.getReconciliationReport(filter.dateFrom).subscribe((res: any) => {
      console.log("Transaction Data : "+JSON.stringify(res));
      if(res.length<=0){
        console.log("No data");
        this.alertService.errorAlertWithMessage("No records present");
      }
      this.rowData = res;
    })
  }

  onSearchBtnClick($event: Event) {
    const filter: CustomerFilter = {}
    debugger
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else{
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }
     if (this.Status != "") {
       } else {
         if (this.searchMerName || '') filter.name = this.searchMerName || '';
       }
       if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
       filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
       filter.name = filter.name + '|'; //added | for userType
    
      if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    // if (this.Status) filter.Status=this.Status||'';
    if (this.searchFromDate) filter.startDate = this.searchFromDate;
    if (this.searchToDate) filter.endDate = this.searchToDate;
    return this.merchantService.getReconciliationReport(filter.dateFrom)
      .subscribe((data) => {
        console.log(data);
        this.rowData = data?.data || data || [],
        this.collectiondata = data?.totalCount || data?.totalrecords || data?.totalRecords || data?.length || 0
        this.collectionSize=this.collectiondata-10
        if(this.rowData.length <=0){
          this.alertService.errorAlertWithMessage("No records present");
          return }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked in Organization List : " + param.data.date);
    return await this.router.navigate(['/reconReport/agentReconReport'], {

      queryParams: {
        mid: param?.data?.date,
      }
    })

  }
  
  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    
    debugger
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: CustomerFilter = {}
    if(this.Status !=""&&this.Status !="undefined")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }


    if (this.Status != "") {
    } else {
      if (this.searchMerName || '') filter.name = this.searchMerName || '';
    }
    if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
    filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
    filter.name = filter.name + '|'; //added | for userType
      //   // if (this.Status != "") {
      // // } else {
      // //   if (this.searchMerName || '') filter.name = this.searchMerName || '';
      // // }
      // // if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
      // filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
    if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    if (this.Status) filter.Status=this.Status||'';
    if (this.user_type) filter.user_type=this.user_type||'';
    if (this.searchFromDate) filter.startDate = this.searchFromDate;
    if (this.searchToDate) filter.endDate = this.searchToDate;
    this.merchantService.getReconciliationReport(filter.dateFrom)
      .subscribe((data) => {
        console.log(data);
          this.rowData = data.data || data.merchants || data;
          this.collectionSize = data.totalCount|| data.totalrecords || data.totalRecords || data.length
          this.collectiondata = data.totalCount|| data.totalrecords || data.totalRecords || data.length

          this.gridApi.applyTransaction({add: this.rowData});
          this.collectionSize=this.collectiondata-10
        }
      );
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: CustomerFilter = {}
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }


    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }
       if (this.Status != "") {
       } else {
         if (this.searchMerName || '') filter.name = this.searchMerName || '';
       }
       if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
       filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
       filter.name = filter.name + '|'; //added | for userType


      //   // if (this.Status != "") {
      // // } else {
      // //   if (this.searchMerName || '') filter.name = this.searchMerName || '';
      // // }
      // // if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
      // filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
    if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    if (this.Status) filter.Status=this.Status||'';
    if (this.searchFromDate) filter.startDate = this.searchFromDate;
    if (this.searchToDate) filter.endDate = this.searchToDate;
    this.merchantService.getReconciliationReport(filter.dateFrom)
      .subscribe((data) => (this.rowData = data.data || data.merchants || data, 
        this.collectiondata = data.totalCount || data.totalRecords,
        this.collectionSize=this.collectiondata-10,
        console.log(data),
         this.gridApi.applyTransaction({add: this.rowData})
        )
        );
         

  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {

    const filter: CustomerFilter = {}
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);

    const currentDate = new Date();
    console.log(filter.dateFrom);
    const cValue = formatDate(currentDate, 'yyyy-MM-dd', 'en-US');
    filter.customerMobile = "";
    filter.dateFrom = cValue;

    console.log(this.dateFrom);

    this.dateFrom = filter.dateFrom;
    return this.merchantService.getReconciliationReport(filter.dateFrom)
      .subscribe((data) => {
        this.rowData = data.data || data.customers || data;
       
        console.log(" Reconciliation Report "+ JSON.stringify(data))
        this.collectiondata = data.totalCount || data.totalrecords || data.totalRecords || data.length
        this.collectionSize=this.collectiondata-10
        this.totalRecords =  data.totalRecords
      });

      
  }

  colorChange(data : any){

    console.log("Color : "+data);
    
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.searchFromDate = '';
      this.searchToDate = '';
      this.refreshGrid();
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }
  changeDate(){
    // this.currentDate=this.searchFromDate
  }


  changeEndDate()
  {
    this.currentDate=this.searchToDate
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

 

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event : any){    
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }
  allowAlfanumeric($event: Event): void {
    if(this.searchMID.length>10)
    {
      return
    }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {

    const filter: CustomerFilter = {}
    this.gridApi.applyTransaction({remove: this.rowData});
    return this.merchantService.getReconciliationReport(filter.dateFrom)
      .subscribe((data) => (this.rowData = data.data || data.merchants || data, 
        this.collectiondata = data.totalCount || data.totalrecords || data.totalRecords || data.length,  this.collectionSize=this.collectiondata-10
        
        ));
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }


}
